<template>
<div>
    <div class="mcc-page-header">
        <div>
            <div class="mu-d-flex">
                <h1 class="mu-mb-00">Custom View Details</h1>
                <details class="mcc-popover mcc-popover--bottom-end">
                    <summary class="mcc-button mcc-button--icon-only ">
                        <mcc-icon name="info" aria-hidden="true"></mcc-icon>
                    </summary>
                    <div class="mcc-popover__content">
                        <p>
                            {{ (isEditPage && !isCopyPage) ? helpTextEdit.title : helpTextCreate.title }}
                            <a :href="helpTextCreate.url" target="_blank">Read more...</a>
                        </p>
                    </div>
                </details>
            </div>
        </div>
    </div>
    <div class="mcc-container--fluid card-padding">
        <div>
            <nav aria-label="breadcrumb">
                <ol class="mcc-breadcrumb">
                    <li>Process Engine</li>
                    <li>
                        <router-link :to="CONTEXT_PATH + '/processengine/processes'">Instances</router-link>
                    </li>
                    <li aria-current="page">{{(isEditPage & !isCopyPage) ? customViewName : 'Create New'}}</li>
                </ol>
            </nav>
        </div>
        
       
        <form novalidate id="customViewForm" @submit.prevent="save()" >
            <div class="mcc-row" v-show="!fetchCall">
                <div class="mcc-col colSpinner">
                    <div class="spinner-overlay">
                        <div class="spinner-background"></div>
                        <div class="spinner-flex">
                            <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div class="mcc-card mu-p-06">
                    <div class="mcc-row" v-show="fetchCall">
                        <div class="mcc-row" v-if="fetchCall">
                            <div class="mcc-col">
                                <mcc-alert role="alert" class="mcc-alert mcc-alert--warning mcc-alert--compact" v-show="isEditPage && !isCopyPage && !isOwner" color="warning">
                                    <mcc-icon name="error" aria-hidden="true"></mcc-icon>
                                    <p  v-if="isEditable">This custom view is shared with editable rights by {{sharedByUserFN}} {{sharedByUserLN}}.</p>
                                    <p v-if="!isEditable">This custom view is shared with read-only rights by {{sharedByUserFN}} {{sharedByUserLN}}, please contact owner for editable rights.</p>
                                </mcc-alert>
                            </div>
                        </div>
                        <div class="mcc-col">
                            <div class="mcc-card">
                                <div class="mcc-card__header">
                                    <h2 class="mcc-card__title">Details</h2>
                                </div>
                                <div class="mcc-card__body">
                                    
                                    <div class="mfc-slim-select-wrapper mfc-form-input-wrapper--width mu-mb-03 mfc-form-input-container">
                                        <label for="processDefinitionIdCVProcess" class="mfc-label--required mu-mb-00">Process</label>
                                        <select class="mfc-slim-select" required @change="handleProcessChange($event)" :disabled="isEditPage" ref="processDefinitionId" name="processDefinitionId" id="processDefinitionIdCVProcess">
                                        </select>
                                    </div>
                                    <div class="mfc-slim-select-wrapper mfc-form-input-wrapper--width  mu-mb-03 mfc-form-input-container">
                                        <label for="variablesCVProcess" class="mfc-label--required mu-mb-00">Process Variables</label>
                                        <select class="mfc-slim-select slimHeight"  @change="changeProcessVariable($event)" ref="variables" name="variables" id="variablesCVProcess" required  multiple>
                                        </select>
                                        <div class="[ mfc-help-text ] ">
                                            
                                            <span>Maximum 10 variables can be selected.</span>
                                        </div>
                                    </div>
                                    <div class="mfc-input-wrapper mfc-form-input-wrapper--width mfc-form-input-container">
                                        <label for="nameCVProcess" class="mfc-label--required"> Name</label>
                                        <input type="text" name="name" maxlength="50" id="nameCVProcess" required="" :disabled="isEditPage && !isCopyPage && !isEditable" @change="updateName($event)" ref="name" :pattern="nameRegex">

                                    </div>
                                    <div class="mu-d-flex mu-justify-content-end d-flex justify-content-end mu-mt-06 mu-gap-05" >
                                        <div role="group" class="mcc-button-group ">
                                            <router-link v-if="!isEditPage" :to="CONTEXT_PATH + '/processengine/processes'">
                                                <button class="mcc-button mcc-button--outline" title="Cancel" id="customViewProcessCancelBtn">
                                                    <mcc-icon name="cancel" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Cancel</span>
                                                </button>
                                            </router-link>
                                            <router-link v-if="isCopyPage" :to="CONTEXT_PATH + '/processengine/processes/customview/' + customViewId">
                                                <button class="mcc-button mcc-button--outline" title="Cancel" id="customViewProcessCancelBtn">
                                                    <mcc-icon name="cancel" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Cancel</span>
                                                </button>
                                            </router-link>
                                            <div role="group" class="mcc-button-group mcc-menu__split-button mu-m-00" v-if="isEditPage && !isCopyPage && isEditable">

                                                <button type="button" class="mcc-button mcc-button--outline" id="copyBtn" @click="handleCopyClick()" title="Copy">
                                                    <mcc-icon name="copy" aria-hidden="true"></mcc-icon>
                                                    <span class="mcc-button__label">Copy</span>
                                                </button>
                                                <details class="mcc-dropdown">
                                                    <summary class="mcc-button mcc-button--outline mu-border-start" aria-haspopup="true">
                                                        <span class="[ mcc-button__label ] [ mu-visually-hidden ]">Dropdown</span>
                                                        <mcc-icon class="[ mcc-button__dropdown-caret ] [ mu-ml-00 ] " style="margin-right:0px !important;" name="expand_arrow" aria-hidden="true"></mcc-icon>
                                                    </summary>
                                                    <ul class="mcc-dropdown__menu">
                                                        <li>
                                                            <button type="button" @click="showDeleteProcessCustomViewDialog()" title="Delete" id="deleteCustomViewProcessBtn">
                                                                <mcc-icon name="trash" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Delete</span>
                                                            </button>
                                                            <button type="button" @click="showShareDialog()" title="Share" id="shareBtn">
                                                                <mcc-icon name="share" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Share</span>
                                                            </button>

                                                        </li>
                                                    </ul>
                                                </details>
                                            </div>

                                        </div>
                                        <button type="button" class="mcc-button mcc-button--outline" v-if="isEditPage && !isCopyPage && !isEditable" id="copyBtn" title="Copy" @click="handleCopyClick()">
                                            <mcc-icon name="copy" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Copy</span>
                                        </button>
                                        <button type="button" class="mcc-button mcc-button--soft-primary" v-if="isEditable || !isEditPage || isCopyPage" title="Preview" id="previewBtnProcess" @click="generatePreviewBtnClick()">
                                            <mcc-icon name="preview_pane" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Preview</span>
                                        </button>
                                        <button class="mcc-button mcc-button--success" v-if="isEditable || !isEditPage || isCopyPage" title="Save" id="customViewProcessSubmitBtn"  type="submit">
                                            <mcc-icon name="save" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Save</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mcc-row mu-mt-06" v-show="previewCall">
                        <div class="mcc-col mcc-col-md-12">
                            <div style="position:relative">
                                <div class="mcc-card" v-show="showPreviewGrid">
                                    <div class="mcc-card__header mu-d-flex mu-justify-content-between mu-align-items-start mu-flex-wrap">
                                        <div>
                                            <h2 class="mcc-card__title">Process Variables</h2>
                                        </div>
                                    </div>
                                    <div class="mcc-card__body">
                                        <div class="mcc-row" v-if="isEditable">
                                            <div class="mcc-col">
                                                <div class="mu-d-flex mu-justify-content-end mu-pb-06">
                                                    <button type="button" class="mcc-button mcc-button--outline  mcc-button--sm" @click="$refs.customFilter.open()">
                                                        <mcc-icon name="filter" aria-hidden="true"></mcc-icon>
                                                        <span class="mcc-button__label">Filters {{filterCount > 0 ? ` (${filterCount})` : '(0)'}}</span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <mcc-data-table ref="customViewtableProcess" id="customViewtableProcess"></mcc-data-table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mcc-row" v-show="!previewCall">
                <div class="mcc-col colSpinner">
                    <div class="spinner-overlay">
                        <div class="spinner-background"></div>
                        <div class="spinner-flex">
                            <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            </svg>
                        </div>
                    </div>

                </div>

            </div>

        </form>
    </div>
    <!-- !Filter Drawer Start -->
    <Drawer ref="customFilter" @reset-filter="resetFilter()" @apply-filter="submitDialog()" title="Process Filters" >
    
            <section class="mcc-card mu-border-0">
                <form id="formIdd">
                <div class="mcc-row">
                    <div class="mcc-col">
                        <div>
                            <div class="flatpickr flatpickrGap mfc-input-wrapper  ">
                                <label for="changeDateId" class=" mb-0">Started between</label>
                                <div class="mfc-input-group mfc-input-group--has-help-text mfc-input-group--has-validation-text flatpickrInstance" id="dateFromId" >
                                    <input name="changeDate" id="changeDateId" placeholder="Select Date.." ref="changeDate" icon="calendar" :value="startDateRangeRef" data-input @change="handleStartRangeChange($event)" @ready="handleStartRangeReady()">
                                    <button type="button" class="mcc-button mcc-button--outline" data-toggle aria-label="date">
                                        <mcc-icon name="calendar" aria-hidden="true"></mcc-icon>
                                    </button>
                                    <div id="mds_text_feedback" class="mfc-invalid-feedback">
                                        <mcc-icon name="error" width="24" height="24"></mcc-icon>
                                        <span>Please select proper dates.</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    
                        <div>
                            <div class="flatpickr flatpickrGap mfc-input-wrapper ">
                                <label for="changeToDateId" class=" mb-0">Completed between</label>
                                <div class="mfc-input-group mfc-input-group--has-help-text mfc-input-group--has-validation-text  flatpickrInstances" id="dateToId">
                                    <input name="endDate" id="endDateId" ref="endDate" placeholder="Select Date.." icon="calendar" @change="handleEndRangeChange($event)" :value="endDateRangeRef" @ready="handleEndRangeReady()" data-input>
                                    <button type="button" class="mcc-button mcc-button--outline" data-toggle aria-label="date">
                                        <mcc-icon name="calendar" aria-hidden="true"></mcc-icon>
                                    </button>
                                    <div id="mds_text_feedback" class="mfc-invalid-feedback">
                                        <mcc-icon name="error" width="24" height="24"></mcc-icon>
                                        <span>Please select proper dates.</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mcc-row">
                    <div class="mcc-col">
                        <div>
                            <div class="mfc-slim-select-wrapper mu-mb-03">
                                <label for="owner-selectId" class="mu-mb-00">Started By</label>
                                <select class="mfc-slim-select" @change="startedByRef = $event.target.value" name="startedByUser" id="startedByUser">
                                    <option data-placeholder="true" value :selected="startedByRef ==''"></option>
                                    <option v-for="(user,key) in allUsers" :selected="startedByRef == user.username" :key="key" :value="user.username">{{user.firstName}} {{user.surname}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            </section>
        
    </Drawer>
    <!-- !Filter Drawer End -->
    <div class="mcc-dialog-overlay">
        <dialog class="mcc-dialog mcc-dialog--xs mcc-dialog--primary" ref="shareDialog" id="shareDialog">
            <form novalidate @submit.prevent="shareCustomView($event)" id="share-dialog-form" >
                <section>
                    <div class="mcc-dialog__header">
                        <h2 class="h4">Share custom view</h2>
                        <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="closeShareDialog()">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                    </div>
                    <div class="mcc-dialog__body">
                        <div class="mcc-row">
                            <div class="mcc-col">
                                <div>
                                    <!-- !Tabs Start -->
                                    <div class="mcc-tabs mcc-tabs--compact mcc-tabs--bar">
                                        <input type="radio" id="readonlyTab" name="as-default-tab-control" checked="">
                                        <input type="radio" id="editableTab" name="as-default-tab-control">
                                        <ul role="tablist" class="mu-mb-05">
                                            <li role="tab">
                                                <label for="readonlyTab" tabindex="0">
                                                    <span>Read only</span>
                                                </label>
                                            </li>
                                            <li role="tab">
                                                <label for="editableTab" tabindex="0">
                                                    <span>Editable</span>
                                                </label>
                                            </li>
                                        </ul>
                                        <div role="tabpanel">
                                            <div>
                                                <div class="mfc-slim-select-wrapper mu-position-relative dialogSlimSelect mfc-form-input-container mu-mb-03">
                                                    <label for="readOnlyUsers" class="mu-mb-00">Users</label>
                                                    <div id="readOnlyUsersSelectedIdDiv"></div>
                                                    <select class="mfc-slim-select" @change="handleChangeROUserSelect()" name="readOnlyUsers" id="readOnlyUsers" ref="readOnlyUsers" multiple>
                                                        <option v-for="(user,key) in allReadOnlyUsers" :key="key" :value="user.username">{{user.firstName}} {{user.surname}}</option>
                                                    </select>
                                                </div>
                                                <div class="mfc-slim-select-wrapper mu-position-relative dialogSlimSelect mfc-form-input-container mu-mb-03">
                                                    <label for="readOnlyGroups" class="mu-mb-00">Groups</label>
                                                    <div id="readOnlyGroupsSelectedIdDiv"></div>
                                                    <select class="mfc-slim-select" @change="handleChangeROGroupSelect()" name="readOnlyGroups" id="readOnlyGroups" ref="readOnlyGroups" multiple>
                                                        <option v-for="(group,key) in allReadOnlyGroups" :key="key" :value="group.id">{{group.name}}</option>
                                                    </select>
                                                </div>
                                               
                                            </div>
                                        </div>
                                        <div role="tabpanel">
                                            <div>
                                                <div class="mfc-slim-select-wrapper mu-position-relative dialogSlimSelect mfc-form-input-container mu-mb-03">
                                                    <label for="editableUsers" class="mu-mb-00">Users</label>
                                                    <div id="editableUsersSelectedIdDiv"></div>
                                                    <select class="mfc-slim-select" @change="handleChangeEditableUserSelect" name="editableUsers" id="editableUsers" ref="editableUsers" multiple>
                                                        <option v-for="(user,key) in allEditableUsers" :key="key" :value="user.username">{{user.firstName}} {{user.surname}}</option>
                                                    </select>
                                                </div>
                                                <div class="mfc-slim-select-wrapper mu-position-relative dialogSlimSelect mfc-form-input-container mu-mb-03">
                                                    <label for="editableGroups" class="mu-mb-00">Groups</label>
                                                    <div id="editableGroupsSelectedIdDiv"></div>
                                                    <select class="mfc-slim-select" @change="handleChangeEditableGroupSelect" name="editableGroups" id="editableGroups" ref="editableGroups" block label="Groups" multiple>
                                                        <option v-for="(group,key) in allEditableGroups" :key="key" :value="group.id">{{group.name}}</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- !Tabs End -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mcc-dialog__footer">
                        <div class="mcc-button-group mcc-button-group--spaced">
                            <button type="button" class="mcc-button mcc-button--outline" @click="closeShareDialog()">Cancel</button>
                            <button type="submit" class="mcc-button mcc-button--primary">Save</button>
                        </div>
                    </div>
                </section>
            </form>
        </dialog>
    </div>
    <div class="mcc-dialog-overlay">
        <dialog class="mcc-dialog mcc-dialog--danger mcc-dialog--xs" v-if="isDataAvailable" ref="deleteProcessCustomViewDialog" id="deleteProcessCustomViewDialog">
            <section>
                <div class="mcc-dialog__header">
                    <h2 class="h4">Delete Custom View</h2>
                    <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="$refs.deleteProcessCustomViewDialog.close()">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                </div>
                <div class="mcc-dialog__body">
                    <div class="mcc-row">
                        <div class="mcc-col">
                            Are you sure you want to delete this custom view?
                        </div>
                    </div>
                </div>
                <div class="mcc-dialog__footer">

                    <div class="mcc-button-group mcc-button-group--spaced">
                        <button type="button" class="mcc-button mcc-button--outline" @click="$refs.deleteProcessCustomViewDialog.close()">No</button>
                        <button type="button" class="mcc-button mcc-button--danger" @click="handleDeleteDialogClose($event)">Yes</button>
                    </div>
                </div>
            </section>
        </dialog>
    </div>
</div>
</template>

<script>
import CustomViewAPI from "../../../services/CustomViewAPI";
import InstanceAPI from "../../../services/InstanceAPI";
import MyProcessListAPI from "../../../services/MyProcessListAPI";
import HierarchyAPI from "../../../services/HierarchyAPI";
import {
    handleFormValidation,
    validationMessages,
    displayErrorMessage
} from '../../../formvalid';
import {
    EventBus
} from "../../../services/event-bus";
import constantMessages from "../../../messages";
import AdminHttpAPI from "../../../services/AdminHttpAPI";
import Utils from "@/script_utils";
import Drawer from "../../common/Drawer.vue";

export default {
    name: "CustomViewProcess",
    components: {
        Drawer
    },
    data() {
        return {
            customView: {
                processVariables: {
                    aliasName: '',
                    type: 'process',
                    variablesjson: '',
                    processDefinitionId: '',
                },
                customViewFilterDTO: {}
            },
            emptyField: {
                "text": "",
                "value": ""
            },
            helpTextCreate: constantMessages.BREADCRUMB_HELP["processengine.processes.customView.create"],
            helpTextEdit: constantMessages.BREADCRUMB_HELP["processengine.processes.customView.edit"],
            nameRegex: constantMessages.PATTERNS["customName"],
            showHelpText: false,
            currentPageSize: 10,
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            processDefinitions: [],
            customViewId: this.$route.params.customViewId,
            isEditPage: true,
            isCopyPage: false,
            fetchCall: false,
            previewCall: true,
            isDataAvailable: false,
            customViewName: '',
            showPreviewGrid: false,
            updateCall: false,
            startedAfter: "",
            startedBefore: "",
            finishedAfter: "",
            finishedBefore: "",
            startDateRangeRef: [],
            endDateRangeRef: [],
            filterVariables: [],
            allUsers: {},
            allReadOnlyUsers: {},
            allEditableUsers: {},
            startedBy: "",
            startedByRef: "",
            showSpinner: false,
            showReadonlyTab: false,
            showEditableTab: false,
            updateShareDialog: false,
            selectedROUsers: [],
            selectedEditableUsers: [],
            isOwner: false,
            isEditable: true,
            usersWithRORight: [],
            usersWithEditableRight: [],
            groupsWithEditableRights: [],
            groupsWithReadOnlyRights: [],
            currentUserName: "",
            sharedByUserFN: "",
            sharedByUserLN: "",
            activeGroups: [],
            selectedROGroups: [],
            selectedEditableGroups: [],
            allEditableGroups: [],
            allReadOnlyGroups: [],
            tableData: [],
            selectProcess: {},
            variablesCVProcessInstance: null,
            variableData: "",
            filterCount: 0,
            updatingSlimSelect: true,
            readOnlyUsersInstance: null,
            readOnlyGroupsInstance: null,
            editableUsersInstance: null,
            editableGroupsInstance:null
        }
    },
    created() {
        Utils.applyFixedHeaderConfiguration(this);
        let self = this;
        self.fetchCall = false;
        self.isEditPage = self.customViewId != null && self.customViewId != 'new';
        self.isCopyPage = self.$route.path.includes("copy");

        if (this.customViewId != null && this.customViewId != 'new') {
            self.getCustomViewData();
        } else {
            let procDefArr = [];
            CustomViewAPI.getLatestProcessDefinitions().then(response => {
                    self.fetchCall = true;
                    if (response != null) {
                        procDefArr.push({
                            value: '',
                            text: ''
                        });
                        $.each(response, function (i, definition) {
                            let obj = {
                                value: definition.id,
                                text: definition.name
                            };
                            procDefArr.push(obj);
                        });
                    }
                })
                .finally(() => {
                    self.setProcessDefinitionData(procDefArr);
                });
        }
        MyProcessListAPI.getUsers().then(result => {
            self.allUsers = result;
            self.allReadOnlyUsers = result;
            self.allEditableUsers = result;
        });
        HierarchyAPI.getActiveGroups()
            .then(result => {
                self.activeGroups = result.data;
                self.allEditableGroups = result.data;
                self.allReadOnlyGroups = result.data;
            });
    },
    mounted() {
        this.processDefinitionInstance = new SlimSelect({
            select: '#processDefinitionIdCVProcess',
        });

        this.variablesCVProcessInstance = new SlimSelect({
            select: '#variablesCVProcess',
            settings: {
                closeOnSelect: false,
                maxSelected: 10,
                allowDeselect: true
            },

        });
        this.readOnlyUsersInstance = new SlimSelect({
            select: '#readOnlyUsers',
            settings: {
                closeOnSelect: false,
                contentPosition: 'absolute',
                openPosition: 'down',
                contentLocation: document.getElementById('readOnlyUsersSelectedIdDiv')
            }
        });
        this.readOnlyGroupsInstance = new SlimSelect({
            select: '#readOnlyGroups',
            settings: {
                closeOnSelect: false,
                contentPosition: 'absolute',
                openPosition: 'down',
                contentLocation: document.getElementById('readOnlyGroupsSelectedIdDiv')
            }
        });
        this.editableUsersInstance = new SlimSelect({
            select: '#editableUsers',
            settings: {
                closeOnSelect: false,
                contentPosition: 'absolute',
                openPosition: 'down',
                contentLocation: document.getElementById('editableUsersSelectedIdDiv')
            }
        });
        this.editableGroupsInstance = new SlimSelect({
            select: '#editableGroups',
            settings: {
                closeOnSelect: false,
                contentPosition: 'absolute',
                openPosition: 'down',
                contentLocation: document.getElementById('editableGroupsSelectedIdDiv')
            }
        });
        this.startedByUserFilter = new SlimSelect({
            select: '#startedByUser',

        });
        this.filterCount = parseInt(localStorage.getItem("setFilterDataInLocalStorage"));
        this.flatPickr()
    },
    watch: {
        isEditPage: 'checkAndToggleVariablesCVProcessInstance',     
        isCopyPage: 'checkAndToggleVariablesCVProcessInstance',     
        isEditable: 'checkAndToggleVariablesCVProcessInstance',
        allEditableGroups(newValue, oldValue) {
      if (!this.updatingSlimSelect && JSON.stringify(newValue) !== JSON.stringify(oldValue))  {
        this.updateSlimSelects();
      }
    },        
    allReadOnlyGroups(newValue, oldValue) {
      if (!this.updatingSlimSelect && JSON.stringify(newValue) !== JSON.stringify(oldValue))  {
        this.updateSlimSelects();
      }
    },
    allReadOnlyUsers(newValue, oldValue) {
      if (!this.updatingSlimSelect && JSON.stringify(newValue) !== JSON.stringify(oldValue))  {
        this.updateSlimSelects();
      }
    },
    allEditableUsers(newValue, oldValue) {
      if (!this.updatingSlimSelect && JSON.stringify(newValue) !== JSON.stringify(oldValue))  {
        this.updateSlimSelects();
      }
    },
  },

    methods: {
        checkAndToggleVariablesCVProcessInstance() {         
            if (this.isEditPage && !this.isCopyPage && !this.isEditable) {             
                this.variablesCVProcessInstance.disable();         
            } else { 
                this.variablesCVProcessInstance.enable(); 
            } 
        },
        updateSlimSelects()
        {
            let self= this;
            self.updatingSlimSelect = true;
                 self.editableGroupsInstance.setData(self.allEditableGroups.map(user => ({
          text: user.name,
          value: user.id,


        })));
         self.readOnlyGroupsInstance.setData(self.allReadOnlyGroups.map(group => ({
         text: group.name,
          value: group.id,

       })));
     self.editableUsersInstance.setData(self.allEditableUsers.map(user => {
        const fullName = user.surname ? `${user.firstName} ${user.surname}` : user.firstName;
    return {
      text: fullName,
      value: user.username
    };
        }));

     self.readOnlyUsersInstance.setData(self.allReadOnlyUsers.map(user => {
        const fullName = user.surname ? `${user.firstName} ${user.surname}` : user.firstName;
    return {
      text: fullName,
      value: user.username
    };
        }));
       self.editableGroupsInstance.setSelected(self.selectedEditableGroups);
      self.readOnlyGroupsInstance.setSelected(self.selectedROGroups);
      self.editableUsersInstance.setSelected(self.selectedEditableUsers)
      self.readOnlyUsersInstance.setSelected(self.selectedROUsers)

            self.updatingSlimSelect = false;
        },
        changeProcessVariable(e) {
            if (this.variablesCVProcessInstance.getSelected()) {
                this.customView.customViewFilterDTO.variables = this.variablesCVProcessInstance.getSelected();
            }
        },
        async setProcessDefinitionData(procDefArr) {
            await this.$nextTick();
            this.processDefinitionInstance.setData(procDefArr)
        },
        async initializeCustmViewData(data) {
            await this.$nextTick();
            let self = this;
            self.customView = data.customView;
            if (self.isCopyPage) {
                self.customViewName = data.customView.processVariables.aliasName + " - copy";
                if (self.customViewName.length > 50) {
                    self.customViewName = self.customViewName.substr(0, 50);
                }
                data.customView.processVariables.aliasName = self.customViewName;
            } else {
                self.customViewName = data.customView.processVariables.aliasName;
            }
            if (self.$refs.name != undefined) {
                self.$refs.name.value = self.customViewName;
            }
            let pageTitle = constantMessages.PAGEHEADER_TITLE["menu.customview.details"] + " - " + self.customViewName;
            if (!self.isEditPage || self.isCopyPage) {
                pageTitle = constantMessages.PAGEHEADER_TITLE["menu.customview.details"] + " - Create new";
            }
            EventBus.$emit("update-pageTitle", pageTitle);
        },
        getCustomViewData() {
            let self = this;
            let editData = {};
            CustomViewAPI.getCustomViewData(self.customViewId).then(response => {
                    if (response != null) {
                        self.isDataAvailable = true;
                        editData = response;
                        self.isOwner = response.data.isOwner;
                        self.isEditable = response.data.isEditable;
                        self.usersWithRORight = response.data.usersWithRORight;
                        self.usersWithEditableRight = response.data.usersWithEditableRight;
                        self.groupsWithEditableRights = response.data.editableGroups;
                        self.groupsWithReadOnlyRights = response.data.readOnlyGroups;
                        self.currentUserName = response.data.currentUserName;
                        self.sharedByUserFN = response.data.sharedByFN;
                        self.sharedByUserLN = response.data.sharedByLN;
                    }

                })
                .finally(() => {
                    self.variableData = editData.data.customView.customViewFilterDTO.variables.join(",")
                    self.fetchCall = true;
                    self.initializeCustmViewData(editData.data);
                    self.initializeProcessDefinition(editData.data);
                    self.initializeVariables(editData);
                });
        },
        showShareDialog() {
            let self = this;
            self.updatingSlimSelect = false;
            this.updateShareDialog = true;
            this.showReadonlyTab = true;
            self.$refs.shareDialog.show();
            $("#readonlyTab").prop("checked", true); 
            self.selectedROUsers = self.usersWithRORight;
            self.selectedEditableUsers = self.usersWithEditableRight;
            self.selectedEditableGroups = self.groupsWithEditableRights;
            self.selectedROGroups = self.groupsWithReadOnlyRights;
                let editUsers = self.allUsers;
                let readonlyUsers = self.allUsers;
                self.allEditableUsers = editUsers.filter(user => (!self.selectedROUsers.includes(user.username) && self.currentUserName != user.username && self.customView.processVariables.userName != user.username));
                self.allReadOnlyUsers = readonlyUsers.filter(user => (!self.selectedEditableUsers.includes(user.username) && self.currentUserName != user.username && self.customView.processVariables.userName != user.username));


            let editGroup = self.activeGroups;
            let readonlyGroup = self.activeGroups;
            self.allEditableGroups = editGroup.filter(group => {
    if (group.id !== undefined && group.id !== null) {
        return !self.selectedROGroups.includes(group.id)

    } else {
        return false;
    }
});       
self.allReadOnlyGroups = readonlyGroup.filter(group => {
    if (group.id !== undefined && group.id !== null) {
        return !self.selectedEditableGroups.includes(group.id)
    } else {
        return false;
    }
});      
        
        },
        closeShareDialog() {
            this.$refs.shareDialog.close();
            this.updateShareDialog = false;
            this.showReadonlyTab = false;
            this.showEditableTab = false;
        },
        handleTabChange(e) {
            let self = this;
            if ($(e.target).attr("id") == "readonlyTab") {
                this.showEditableTab = false;
                this.showReadonlyTab = true;
                setTimeout(() => {
                    self.$refs.readOnlyUsers.value = self.selectedROUsers;
                    self.$refs.readOnlyGroups.value = self.selectedROGroups;
                }, 0);
            } else {
                this.showReadonlyTab = false;
                this.showEditableTab = true;
                setTimeout(() => {
                    self.$refs.editableUsers.value = self.selectedEditableUsers;
                    self.$refs.editableGroups.value = self.selectedEditableGroups;
                }, 0);
            }
        },
        handleChangeROGroupSelect() {
            let self = this;
            if(self.updatingSlimSelect)
            return;
            self.selectedROGroups = self.readOnlyGroupsInstance.getSelected();
            self.selectedROGroups = self.selectedROGroups.map(value => {
    return Number(value);
});
            let activeROGroups = self.activeGroups;
            self.allEditableGroups = activeROGroups.filter(group => {
    if (group.id !== undefined && group.id !== null) {
        return !self.selectedROGroups.includes(group.id)

    } else {
        return false;
    }
});        },
        handleChangeEditableGroupSelect() {
            let self = this;
            if(self.updatingSlimSelect)
            return;
            self.selectedEditableGroups = self.editableGroupsInstance.getSelected();
            self.selectedEditableGroups = self.selectedEditableGroups.map(value => {
    return Number(value);
});
let activeEditGroup = self.activeGroups;
            self.allReadOnlyGroups = activeEditGroup.filter(group => {
    if (group.id !== undefined && group.id !== null) {
        return !self.selectedEditableGroups.includes(group.id)
    } else {
        return false;
    }
});
        },
        handleChangeROUserSelect() {
            let self = this;
            if(self.updatingSlimSelect)
            return;
            self.selectedROUsers = self.readOnlyUsersInstance.getSelected();
            let activeROUser = self.allUsers;
            self.allEditableUsers = activeROUser.filter(user => (!self.selectedROUsers.includes(user.username) && self.currentUserName != user.username && self.customView.processVariables.userName != user.username));
  },
        handleChangeEditableUserSelect() {
            let self = this;
            if(self.updatingSlimSelect)
            return;
            self.selectedEditableUsers = self.editableUsersInstance.getSelected();
            let activeGroupUser = self.allUsers;
            self.allReadOnlyUsers = activeGroupUser.filter(user => (!self.selectedEditableUsers.includes(user.username) && self.currentUserName != user.username && self.customView.processVariables.userName != user.username));
        },
        shareCustomView(e) {
        let self = this;
            self.$refs.shareDialog.close();
            let customViewShareDTO = [];
            if (!self.isOwner && self.usersWithEditableRight.includes(self.currentUserName)) {
                self.selectedEditableUsers.push(self.currentUserName);
            }

            $.each(self.selectedROGroups, function (i, val) {
                let obj = {
                    "groupId": val,
                    "accessType": "READONLY"
                };
                customViewShareDTO.push(obj);
            });
            $.each(self.selectedEditableGroups, function (i, val) {
                let obj = {
                    "groupId": val,
                    "accessType": "EDITABLE"
                };
                customViewShareDTO.push(obj);
            });

            $.each(self.selectedROUsers, function (i, val) {
                let obj = {
                    "username": val,
                    "accessType": "READONLY"
                };
                customViewShareDTO.push(obj);
            });
            $.each(self.selectedEditableUsers, function (i, val) {
                let obj = {
                    "username": val,
                    "accessType": "EDITABLE"
                };
                customViewShareDTO.push(obj);
            });
            CustomViewAPI.shareCustomView(self.customViewId, customViewShareDTO).then(response => {
                EventBus.$emit("success-notification", {
                    msg: constantMessages.MESSAGES[response]
                });
                self.usersWithRORight = self.selectedROUsers;
                self.usersWithEditableRight = self.selectedEditableUsers;
                self.groupsWithReadOnlyRights = self.selectedROGroups;
                self.groupsWithEditableRights = self.selectedEditableGroups;
            });
        },
        resetFilter() {
            this.startedBy = "";
            this.startedByRef = "";
            this.startedAfter = "";
            this.startedBefore = "";
            this.finishedAfter = "";
            this.finishedBefore = "";
            this.startDateRangeRef = [];
            this.endDateRangeRef = [];
            this.filterVariables = [];
            this.filterCount = 0;
            this.startedByUserFilter.setSelected([]);
            this.initPreviewTable();
            this.flatPickr();
            if(this.flatPickr('#changeDateId')){
                this.flatPickr('#changeDateId').destroy();
            }
           if(this.flatPickr('#endDateId')){
                this.flatPickr('#endDateId').destroy();
            }
            
        },
        resetFilterBtnClick() {
            this.initPreviewTable();
            this.resetFilter();
        },
        flatPickr() {
            let self = this;
            self.flatPickerInstance = flatpickr('.flatpickrInstance', {
                dateFormat: 'd/M/Y',
                altFormat: 'd/m/Y',
                altInput: true,
                mode: 'range',
                wrap:true,
                defaultDate: [self.startDateRangeRef[0], self.startDateRangeRef[1]],
            })
            self.flatPickerInstance = flatpickr('.flatpickrInstances', {
                dateFormat: 'd/M/Y',
                altFormat: 'd/m/Y',
                altInput: true,
                mode: 'range',
                wrap:true,
                defaultDate: [self.endDateRangeRef[0], self.endDateRangeRef[1]],
            })
        },
        showDialog() {
            let self = this;
            self.updateCall = true;
            setTimeout(function () {
                self.showSpinner = false;
            }, 1000);
        },
        showFilterDialog() {
            this.$refs.filterDialog.show();
            this.showSpinner = true;
        },
        handleStartRangeChange(e) {
            this.startDateRangeRef = "";
            if (e.target.value.length > 1) {
                this.startDateRangeRef = e.target.value.split(' to ');
            }
        },
        handleStartRangeReady() {
            if (this.startDateRangeRef.length > 1) {
                this.$refs.startDate.value =
                    moment(this.startDateRangeRef[0]).format("DD/MM/YYYY") +
                    " to " +
                    moment(this.startDateRangeRef[1]).format("DD/MM/YYYY");
            }
        },
        handleEndRangeChange(e) {
            this.endDateRangeRef = "";
            if (e.target.value.length > 1) {
                this.endDateRangeRef = e.target.value.split(' to ');
            }
        },
        handleEndRangeReady() {
            if (this.endDateRangeRef.length > 1) {
                this.$refs.endDate.value =
                    moment(this.endDateRangeRef[0]).format("DD/MM/YYYY") +
                    " to " +
                    moment(this.endDateRangeRef[1]).format("DD/MM/YYYY");
            }
        },
        submitDialog(e) {
            let form = $('#formIdd')
            if (!form[0].checkValidity()) {
                handleFormValidation(form, validationMessages);
                return;
                
            }
            let self = this;
            self.filterVariables = [];
            self.updateDateRef();
            let rowValues = [];
            $.each(rowValues, function (i, val) {
                let obj = {
                    "varName": val["Variable"],
                    "operator": val["Operator"],
                    "varValue": val["Value"],
                };
                self.filterVariables.push(obj);
            });
            this.startedBy = this.startedByRef;
            this.initPreviewTable();
            this.filterCount = 0
            this.getFilterCount();
            $('#formIdd').closest('#drawerOverlay').removeClass("mcc-drawer--open")
            $('#formIdd').closest('#drawerOverlay').addClass("mcc-drawer--closed")
        },
        getFilterCount() {
            if (this.startedBy != "")
                this.filterCount += 1;
            if (this.startDateRangeRef != "")
                this.filterCount += 1;
            if (this.endDateRangeRef != "")
                this.filterCount += 1;
        },
        updateDateRef() {
            let self = this;
            this.startedAfter = "";
            this.startedBefore = "";
            this.finishedAfter = "";
            this.finishedBefore = "";
            if (self.startDateRangeRef.length > 0) {
                let startDateFrom = self.startDateRangeRef[0];
                let startDateTo = self.startDateRangeRef[1];
                let d = new Date(startDateFrom);
                d.setHours(0, -d.getTimezoneOffset(), 0, 0);
                this.startedAfter = d.toISOString();
                d = new Date(startDateTo);
                d.setHours(23, -d.getTimezoneOffset() + 59, 59, 999);
                this.startedBefore = d.toISOString();
            }
            if (self.endDateRangeRef.length > 0) {
                let endDateFrom = self.endDateRangeRef[0];
                let endDateTo = self.endDateRangeRef[1];
                let ed = new Date(endDateFrom);
                ed.setHours(0, -ed.getTimezoneOffset(), 0, 0);
                this.finishedAfter = ed.toISOString();
                ed = new Date(endDateTo);
                ed.setHours(23, -ed.getTimezoneOffset() + 59, 59, 999);
                this.finishedBefore = ed.toISOString();
            }
        },
        closeDialog() {
            this.updateCall = false;
        },
        initializeProcessDefinition(data) {
            let self = this;
            let obj = [{
                value: data.customView.processVariables.processDefinitionId,
                text: data.customView.processDefinitionName
            }];
            setTimeout(() => {
                this.processDefinitionInstance.setData(obj)
            }, 100);
        },

        initializeVariables(response) {
            let self = this;
            let varArr = [];
            $.each(response.data.allVariables, function (i, value) {
                let obj = {
                    text: value,
                    value: value
                };
                varArr.push(obj);
            });
            setTimeout(()=>{
                self.setFilterData(response.data.customView.customViewFilterDTO);
            })
            
            self.variablesCVProcessInstance.setData(varArr);
            setTimeout(() => {
                self.variablesCVProcessInstance.setSelected(this.variableData.split(","));
                self.generatePreview();
            }, 1000);
        },
        setFilterData(customViewFilterDTO) {
            this.startedBy = customViewFilterDTO.startedBy;
            this.startedByRef = customViewFilterDTO.startedBy;
            this.startDateRangeRef = customViewFilterDTO.startDateRange;
            this.endDateRangeRef = customViewFilterDTO.endDateRange;
            if(document.querySelector('#startedByUser')?.slim){
                this.startedByUserFilter.destroy()
            }
            this.startedByUserFilter = new SlimSelect({
                select: '#startedByUser'		
            })
            this.startedByUserFilter.setSelected(this.startedByRef);
            document.querySelector("#dateFromId")._flatpickr.setDate(this.startDateRangeRef);
            document.querySelector("#dateToId")._flatpickr.setDate(this.endDateRangeRef);
            this.filterCount = 0;
            this.getFilterCount();
            this.updateDateRef();
            this.filterVariables = customViewFilterDTO.variableFilterDTOs;
        },
        handleProcessChange(e) {
            let self = this;
            let processDefinitionId;
            this.variablesCVProcessInstance.setData([self.emptyField])

            processDefinitionId = $("#processDefinitionIdCVProcess")[0].value;
            self.customView.processVariables.processDefinitionId = processDefinitionId;
            if (processDefinitionId != "") {
                CustomViewAPI.getProcessvariablesForProcess(processDefinitionId).then(response => {
                    let varArr = [];
                    this.variablesCVProcessInstance.setData([self.emptyField])
                    if (response != null) {
                        $.each(response, function (i, value) {
                            let obj = {
                                text: value,
                                value: value
                            };
                            varArr.push(obj);
                        });
                        this.variablesCVProcessInstance.setData(varArr);
                    }
                });
            }
        },
        save() {
            let form = $('#customViewForm')
            if (!form[0].checkValidity()) {
                handleFormValidation(form, validationMessages);
                return;
            }
            let self = this;
            self.customView.customViewFilterDTO.startedBy = self.startedBy;
            self.customView.customViewFilterDTO.startDateRange = self.startedAfter != "" ? self.startDateRangeRef : [];
            self.customView.customViewFilterDTO.endDateRange = self.finishedAfter != "" ? self.endDateRangeRef : [];
            self.customView.customViewFilterDTO.variableFilterDTOs = self.filterVariables;
            CustomViewAPI.saveCustomView(self.customView, self.isCopyPage ? "new" : self.customViewId).then(response => {
                if (response.error) {
                    for (let k in response.messages) {
                        if (k == "aliasName") {
                            displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES[response.messages[k]])
                            self.$refs.name.classList.add("ms-is-invalid")
                        }
                    }
                } else {
                    self.customViewName = response.data.processVariables.aliasName;
                    EventBus.$emit("success-notification", {
                        msg: constantMessages.MESSAGES[response.message]
                    });
                    let customViewList = [];
                    AdminHttpAPI.getCustomViews().then(customViews => {
                        customViewList = customViews.processTypeList;
                        EventBus.$emit("updateCustomViewProcessDrilldown", customViewList);
                    });
                    if (self.isEditPage && !self.isCopyPage) {
                        this.initPreviewTable();
                    } else {
                        this.$router
                            .push(
                                this.CONTEXT_PATH + "/processengine/processes/customview/" + response.data.processVariables.id
                            )
                    }

                }
            }).finally(() => {});
        },
        generatePreviewBtnClick() {
            this.resetFilter();
            this.generatePreview();
        },
        handleCopyClick() {
            let self = this;
            this.$router
                .push(
                    this.CONTEXT_PATH + '/processengine/processes/customview/' + self.customViewId + '/copy'
                )
        },
        generatePreview() {
            let self = this;
            let validationError = false;
            let procId = self.customView.processVariables.processDefinitionId;
            if (procId == null || procId == "") {
                displayErrorMessage($(self.$refs.processDefinitionId), "Process is required")
                self.$refs.processDefinitionId.classList.add("ms-is-invalid")
                validationError = true;
            }
            let selVars = $("#variablesCVProcess")[0].value;
            if (selVars.length == 0) {
                displayErrorMessage($(self.$refs.variables), "Process variables is required")
                self.$refs.variables.classList.add("ms-is-invalid")
                validationError = true;
            }
            if (validationError) {
                return;
            }
            self.showPreviewGrid = true;
            self.initPreviewTable();

        },
        initPreviewTable() {
            let self = this;
            self.previewCall = false;
            if (this.tableObj != null) {
                this.currentPageSize = this.tableObj.tableContext.store.state.pageSize;
            }
            let prop = {
                processDefinitionName: {
                    type: "string",
                    title: "Process",
                    sortable: false,
                    columnSearch: false,
                    template: '<div class="dateTemplate"><a class="name-link" data-id="{{processInstanceId}}">{{processDefinitionName}}</a></div>',
                },
                startUserId: {
                    type: "string",
                    title: "Started by",
                    sortable: false,
                    columnSearch: false
                },
                prettyStartTime: {
                    type: "string",
                    title: "Started",
                    sortable: true,
                    template: '<div class="dateTemplate"><u>{{prettyStartTime}}</u><div>{{startTimeObject}}</div></div>',
                    columnSearch: false
                },
                prettyEndTime: {
                    type: "string",
                    title: "Completed",
                    sortable: true,
                    template: '<div class="dateTemplate"><u>{{prettyEndTime}}</u><div>{{endTimeObject}}</div></div>',
                    columnSearch: false
                },
                prettyDurationInMillis: {
                    type: "string",
                    title: "Duration",
                    template: '<div class="dateTemplate"><u>{{prettyDurationInMillis}}</u><div>{{durationInMillis}}</div></div>',
                    sortable: true,
                    columnSearch: false
                }
            };

            let selectedVariables = self.customView.customViewFilterDTO.variables;
            $.each(selectedVariables, function (i, value) {
                prop[selectedVariables[i]] = {
                    type: "string",
                    title: selectedVariables[i],
                    sortable: false,
                    columnSearch: false
                }
            });
            const table = document.getElementById("customViewtableProcess");
            this.tableObj = window.tableFactory.create(table, {
                bordered: true,
                striped: true,
                emptyTemplate: '<p class="text-center m-0">No process instances found</p>',
                loadingTemplate: '<p class="text-center m-0">Loading...</p>',
                columnSearch: false,
                pageSize: self.currentPageSize,
                debounceTime: 1000,
                schema: {
                    properties: prop
                },
                data: (
                    start,
                    limit,
                    sortHeader,
                    sortDirection,
                    fullTextQuery,
                    searchColumns
                ) => {
                    if (!self.filterActive) {
                        if (self.tableObj != null) {
                            self.currentPageSize =
                                self.tableObj.tableContext.store.state.pageSize;
                        }

                        if (sortHeader == null) {
                            sortHeader = "prettyStartTime";
                        }
                        if (sortDirection == null) {
                            sortDirection = "desc";
                        }
                        if (sortHeader == "prettyStartTime") {
                            sortHeader = "startTime";
                        } else if (sortHeader == "prettyEndTime") {
                            sortHeader = "endTime";
                        } else if (sortHeader == "prettyDurationInMillis") {
                            sortHeader = "duration";
                        }
                        let procDefName = "";
                        if (self.isEditPage) {
                            procDefName = self.customView.processDefinitionName;
                        } else {
                            procDefName = $("#processDefinitionIdCVProcess option:selected")[0].innerText;
                        }
                        let queryString =
                            "start=" +
                            start +
                            "&length=" +
                            self.currentPageSize +
                            "&sort=" +
                            sortHeader +
                            "&dir=" +
                            sortDirection +
                            "&processDefinitionName=" +
                            procDefName +
                            "&includeVariables=true";

                        if (self.startedBy != "") {
                            queryString += "&startedBy=" + encodeURI(self.startedBy);
                        }
                        if (self.startedAfter != "") {
                            queryString +=
                                "&startedAfter=" +
                                self.startedAfter +
                                "&startedBefore=" +
                                this.startedBefore;
                        }
                        if (self.finishedAfter != "") {
                            queryString +=
                                "&finishedAfter=" +
                                self.finishedAfter +
                                "&finishedBefore=" +
                                self.finishedBefore;
                        }

                        return InstanceAPI.getProcessInsatnces(queryString, self.filterVariables).then(result => {
                            let responseData = {
                                totalCount: 0,
                                data: []
                            };
                            responseData.totalCount = result.recordsTotal;

                            result.data.forEach(element => {
                                element['startTimeObject'] = (element.startTimeInDate != null) ?
                                    Utils.getMomentDateString(element.startTimeInDate) : '';

                                element['endTimeObject'] = (element.endTimeInDate != null) ?
                                    Utils.getMomentDateString(element.endTimeInDate) : '';

                                element['durationInMillis'] = (element.durationInMillis != null) ?
                                    element.durationInMillis + ' ms' : '';
                            });

                            self.updateDynamicParameters(responseData, result);

                            return responseData;

                        });
                    } else {
                        self.filterActive = false;
                        let responseData = {
                            totalCount: self.filterData.length,
                            data: self.filterData
                        };
                        return responseData;
                    }
                },
                onAfterDataLoad: (start, limit) => {
                    self.previewCall = true;
                    self.updateProcessTemplate();
                }
            });
        },
        updateProcessTemplate() {
            let self = this;
            this.$refs.customViewtableProcess
                .querySelectorAll('td [class="name-link"]')
                .forEach(btn => {
                    btn.addEventListener("click", e => {
                        let targetEle = e.target;
                        if (targetEle != null) {
                            let procInstId = $(targetEle).attr("data-id");
                            self.$router.push(
                                self.CONTEXT_PATH +
                                "/processengine/processes/processinstance/" + procInstId.trim() + "/all"
                            );
                        }
                    });
                });
        },
        updateDynamicParameters(responseData, result) {
            let self = this;
            if (result.data != null) {
                result.data.forEach(row => {
                    let selectedVars = self.customView.customViewFilterDTO.variables;

                    if (selectedVars != null && selectedVars.length > 0) {
                        for (let i = 0; i < selectedVars.length; i++) {
                            row[selectedVars[i]] = "";
                        }
                    }

                    if (row.customProcessVariables != null) {
                        for (const property in row.customProcessVariables) {
                            row[property] =
                                row.customProcessVariables[property];
                        }
                    }
                });
                responseData.data = result.data;
                self.tableData = responseData.data;
            }
        },
        handleDeleteDialogClose(e) {
            let self = this;
            CustomViewAPI.deleteCustomView(self.$route.params.customViewId).then(response => {
                if (response != null && response.error == false) {
                    EventBus.$emit("success-notification", {
                        msg: constantMessages.MESSAGES[response.message]
                    });

                    let customViewList = [];
                    AdminHttpAPI.getCustomViews().then(customViews => {
                        customViewList = customViews.processTypeList;
                        EventBus.$emit("updateCustomViewProcessDrilldown", customViewList);
                    });

                    self.$router.push(
                        self.CONTEXT_PATH + '/processengine/processes'
                    );
                }
            });
        },
        updateName(event) {
            let self = this;
            if (event.target.value == "") {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.required"])
                self.$refs.name.classList.add("ms-is-invalid")
            } else if (event.target.value.length > 50) {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.length"])
                self.$refs.name.classList.add("ms-is-invalid")
            } else if (!event.target.value.match(this.nameRegex)) {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.invalid"])
                self.$refs.name.classList.add("ms-is-invalid")
            } else {
                self.$refs.name.classList.remove("ms-is-invalid")
            }
            self.customView.processVariables.aliasName = event.target.value;
        },
        showDeleteProcessCustomViewDialog() {
            this.$refs.deleteProcessCustomViewDialog.show();
        }
    }
}
</script>

<style scoped>
.ss-main {
    min-height: 40px !important;
}
</style>
